<div class="card">
  <div class="card-header compact">
    <h1 class="ellipsis" test-id="project-label">{{ project.label || 'No Project Label' }}</h1>
    <div class="card-actions">
      <app-button-group class="compact fill-white">
        @if (permissions.editMetadata) {
          <button color="accent" mat-flat-button test-id="save-button" type="button" (click)="saveChanges()">
            Save
          </button>
        }
        @if (permissions.editMetadata) {
          <button mat-stroked-button test-id="reset-button" type="button" (click)="resetForm()">Reset</button>
        }
      </app-button-group>
    </div>
  </div>
  <form>
    <div class="info-row">
      @if (permissions.editMetadata) {
        <mat-icon
          class="field-tooltip xs"
          fwTooltip="Selecting a different project from this dropdown will move this container to the selected project."
          test-id="project-change-help"
          >info</mat-icon
        >
      }
      @if (!permissions.editMetadata) {
        <span class="field-tooltip"></span>
      }
      <span class="field-label">Project</span>
      <div class="field-value">
        @if (!permissions.editMetadata) {
          <span>{{ project.label }}</span>
        }
        @if (permissions.editMetadata) {
          <mat-select test-id="project-select" [formControl]="projectId">
            @for (group of groupedProjects$ | async; track group) {
              <mat-optgroup [label]="groupLabel(group)">
                @for (project of group.projects; track project) {
                  <mat-option [value]="project._id">
                    {{ project.label || project._id }}
                  </mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
        }
      </div>
      <div class="field-error"></div>
    </div>
    <div class="info-row">
      <span class="field-tooltip"></span>
      <span class="field-label">Group</span>
      <div class="field-value">
        <span test-id="group-label">{{ groupLabel(group) }}</span>
      </div>
      <div class="field-error"></div>
    </div>
    <div class="info-row">
      <span class="field-tooltip"></span>
      <span class="field-label">Sessions</span>
      <div class="field-value">
        <span test-id="session-count">{{ projectStats?.session_count }}</span>
      </div>
      <div class="field-error"></div>
    </div>
    <div class="info-row">
      <span class="field-tooltip"></span>
      <a color="primary" mat-flat-button test-id="view-project-button" [routerLink]="projectHref"> View Project </a>
    </div>
  </form>
</div>
